import React, { useEffect, useState } from "react";
import "../../styles/college-syllabus/main.css";
import { getAllSyllabus } from "../../Services/AllAPIs";
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [coursesData, setCoursesData] = useState([]);
    const [error, setError] = useState(null);

    const getSyllabus = () => {
        getAllSyllabus()
            .then((res) => {
                // console.log('----->', res.data);
                setCoursesData(res.data);
                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching department data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getSyllabus();
    }, []);

    return (
        <div id="collegeSyllabusMain">
            <div className="container mt-5 mb-5 admin-container">
                <div className="new-things">
                    {loader && <LoadingSpinner />}

                    {error && <div className="error">{error}</div>}

                    {/* Loop through the courses data */}
                    {coursesData.map((course) => (
                        <div className="row-new" key={course.id}>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        {course.course_name}
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Loop through the syllabus for each course */}
                                                {course.syllabus &&
                                                    course.syllabus.map((syllabus) => (
                                                        <tr key={syllabus.id}>
                                                            <td>{syllabus.name}</td>
                                                            <td>
                                                                <button className="btn btn-primary btn-download">
                                                                    <a
                                                                        href={syllabus.url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        Download
                                                                    </a>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Main;
